import { useAxios } from './axiosService';

export const useTransactionService = () => {
    const { axios } = useAxios();

    const getTransactions = (offset, limit) => {
        return axios.get('/transactions', {
            params: {
                offset,
                limit,
            },
        });
    };

    return {
        getTransactions,
    };
};
